var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTableBody",
    _vm._l(6, function(_, index) {
      return _c(
        "CompassTableRow",
        {
          key: "objectives-listing-table__table-loader-" + index,
          staticClass: "objectives-listing-table__table--loading"
        },
        [
          _vm._l(_vm.columns, function(column) {
            return _c(
              "CompassTableBodyCell",
              {
                key:
                  "objectives-listing-table__table-loader-" +
                  index +
                  "-column-" +
                  column.code,
                attrs: { minWidth: column.width }
              },
              [_c("CompassSkeleton")],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "CompassTableBodyCell",
            { attrs: { minWidth: "48px" } },
            [_c("CompassSkeleton")],
            1
          )
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }